import { EmployerRole, Permission } from '@typings/app/rbac.types';

export const ROLE_PERMISSIONS: Record<EmployerRole, Permission[]> = {
  super_admin: [
    'admin.users.view',
    'admin.users.manage',
    'admin.companies.view',
    'admin.reports.view',
    'recruitment.roles.view',
    'recruitment.roles.create',
    'recruitment.roles.edit',
    'recruitment.candidates.view',
    'recruitment.candidates.manage',
    'recruitment.interviews.view',
    'recruitment.interviews.schedule',
    'hr.planning.view',
    'hr.planning.manage',
    'hr.locations.view',
    'hr.locations.manage',
    'hr.locations.create',
    'hr.locations.edit',
    'hr.position-templates.view',
    'workforce.onboarding.view',
    'workforce.employees.view',
    'workforce.scheduling.view',
    'workforce.attendance.view',
    'workforce.payroll.view',
    'settings.profile.edit',
    'settings.company.edit',
    'settings.billing.manage',
  ],
  hr: [
    'recruitment.roles.view',
    'recruitment.candidates.view',
    'recruitment.candidates.manage',
    'recruitment.interviews.view',
    'recruitment.interviews.schedule',
    'hr.planning.view',
    'hr.planning.manage',
    'hr.locations.view',
    'hr.position-templates.view',
    'settings.profile.edit',
  ],
};
